import { Outlet } from 'react-router-dom';
import { Result } from 'antd';
import type { ReactNode } from 'react';
import { usePackagingPermission, type PackagingAccess } from '../../hooks/common/usePackagingPermission.ts';

export default function PackagingGuard({ access, children }: { access: PackagingAccess; children?: ReactNode }) {
  const permissions = usePackagingPermission();
  const allowed = access === 'vendor' ? permissions.canUseVendorPackaging
    : access === 'read' ? permissions.canReadPackaging
      : access === 'write' ? permissions.canWritePackaging
        : permissions.canAdministerPackaging;
  return allowed ? <>{children ?? <Outlet />}</> : <Result status="403" title="Access Denied" />;
}